// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get } from "./api_client";
import { OptionValueString, IOptionValueString } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getTimezoneOptions(): ApiResult<OptionValueString[]> {
	return get<IOptionValueString[]>(`/api/timezone/timezone-options`).then(result => result === undefined ? undefined : result.map(o => new OptionValueString(o)));
}
